const PerformanceMetrics = {
  name: 'PerformanceMetrics',
  type: 'object',
  properties: {
    Impressions: {
      type: 'integer',
      nullable: true,
    },
    Clicks: {
      type: 'integer',
      nullable: true,
    },
    CTR: {
      type: 'number',
      nullable: true,
    },
    Conversions: {
      type: 'integer',
      nullable: true,
    },
    Spend: {
      type: 'number',
      nullable: true,
    },
    AverageCPC: {
      type: 'number',
      nullable: true,
    },
    AveragePosition: {
      type: 'number',
      nullable: true,
    },
    AverageCPM: {
      type: 'number',
      nullable: true,
    },
    CPA: {
      type: 'number',
      nullable: true,
    },
    WebsiteCoverage: {
      type: 'number',
      nullable: true,
    },
    AuctionWonPercent: {
      type: 'number',
      nullable: true,
    },
    AuctionLostToBudgetPercent: {
      type: 'number',
      nullable: true,
    },
    AuctionLostToRankPercent: {
      type: 'number',
      nullable: true,
    },
    AuctionLostToLandingPercent: {
      type: 'number',
      nullable: true,
    },
    AuctionLostToAdQualityPercent: {
      type: 'number',
      nullable: true,
    },
    AuctionLostToBidPercent: {
      type: 'number',
      nullable: true,
    },
    ClickSharePercent: {
      type: 'number',
      nullable: true,
    },
    RevenueOnAdSpend: {
      type: 'number',
      nullable: true,
    },
    AdvertiserReportedRevenue: {
      type: 'number',
      nullable: true,
    },
    ConversionRate: {
      type: 'number',
      nullable: true,
    },
  },
};

export const Label = {
  name: 'Label',
  type: 'object',
  key: 'Id',
  properties: {
    Id: {
      type: 'integer',
      key: true,
      nullable: true,
    },
    Name: {
      type: 'string',
      maxLength: 80,
      required: true,
    },
    Description: {
      type: 'string',
      maxLength: 200,
    },
    ColorCode: {
      type: 'integer',
      nullable: true,
    },
    AssociationCounts: {
      type: 'object',
      $schema: {
        name: 'LabelAssociationCounts',
        type: 'object',
        properties: {
          CampaignCount: {
            type: 'integer',
          },
          AdGroupCount: {
            type: 'integer',
          },
          AdCount: {
            type: 'integer',
          },
          KeywordCount: {
            type: 'integer',
          },
        },
      },
    },
  },
};

export const CustomParameter = {
  name: 'CustomParameter',
  type: 'object',
  properties: {
    Key: {
      type: 'string',
    },
    Value: {
      type: 'string',
    },
  },
};

export const AppUrl = {
  name: 'AppUrl',
  type: 'object',
  properties: {
    OsType: {
      type: 'string',
    },
    Url: {
      type: 'string',
    },
  },
};

export const Appeal = {
  name: 'Appeal',
  type: 'object',
  properties: {
    IsAppealable: {
      type: 'boolean',
    },
    JustificationText: {
      type: 'string',
    },
  },
};

export const Ad = {
  name: 'Ad',
  type: 'object',
  key: 'Id',
  properties: {
    Id: {
      type: 'integer',
      key: true,
      filterable: true,
    },
    Text: {
      type: 'string',
      filterable: true,
    },
    Title: {
      type: 'string',
      filterable: true,
    },
    DisplayUrl: {
      type: 'string',
      filterable: true,
    },
    DestinationUrl: {
      type: 'string',
      filterable: true,
    },
    Type: {
      type: 'string',
      enum: ['Text', 'Mobile', 'Product', 'AppInstall', 'DynamicSearch', 'ExpandedText', 'Responsive'],
      filterable: true,
    },
    DevicePreference: {
      type: 'string',
      enum: ['All', 'Mobile'],
      nullable: true,
      filterable: true,
    },
    Status: {
      type: 'string',
      filterable: true,
      enum: ['Inactive', 'Active', 'Paused', 'Deleted'],
    },
    DeliveryStatus: {
      type: 'string',
      filterable: true,
      enum: ['CreditCardExpired', 'IOExceeded', 'PaymentInformationMissing', 'InvalidFinancialStatusOther', 'MigrationPaused', 'CampaignDeleted', 'CampaignSuspended', 'CampaignBudgetPaused', 'DomainLanguageNotSupported', 'ShoppingCampaignStoreNotFound', 'ShoppingCampaignNoOffersPresent', 'AdGroupExpired', 'AdGroupDraft', 'AdGroupDeleted', 'CamAssetRejected', 'CamAssetDeleted', 'AdGroupTargetingTooNarrow', 'EditorialRejected', 'EditorialUnderAppeal', 'UrlInvalid', 'ApplicationNotFound', 'ApplicationDestinationUrlMismatch', 'PendingMetadataSync', 'EditorialPending', 'AssociationDeleted', 'CampaignUserPaused', 'AdGroupPrivacyPending', 'AdGroupUserPaused', 'AdUserPaused', 'KeywordMatchTypeAdGroupMediumCombinationInvalid', 'KeywordUserPaused', 'NegativeKeywordConflicts', 'EditorialApprovedLimited', 'LowSupply', 'LowQuality', 'BidBelowFirstPageBid', 'Incomplete', 'BudgetSuggestions', 'InlineOpportunity', 'GeoCodingIncomplete', 'ProductTargetUserPaused', 'AdExtensionNotPresent', 'AdExtensionDeleted', 'AdExtensionAssociationDeleted', 'StoreIdNotAssociated', 'AdGroupAudienceAssociationPaused', 'AdGroupAudienceAssociationExcluded', 'AdNotPresent', 'AdNotActive', 'ApplicationDestinationUrlValidationIncomplete', 'Eligible', 'DisclaimerInfoRejected'],
    },
    DeliveryStatusDetails: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    PerformanceMetrics: {
      type: 'object',
      $schema: PerformanceMetrics,
    },
    UpdatedOnLastImport: {
      type: 'boolean',
    },
    TrackingUrlTemplate: {
      type: 'string',
      filterable: true,
    },
    UrlCustomParameters: {
      type: 'array',
      items: {
        type: 'object',
        $schema: CustomParameter,
      },
    },
    FinalUrls: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    MobileFinalUrls: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    AppFinalUrls: {
      type: 'array',
      items: {
        type: 'object',
        $schema: AppUrl,
      },
    },
    Appeal: {
      type: 'object',
      $schema: Appeal,
    },
    Campaign: {
      type: 'object',
      filterable: ['Name', 'Id'],
      schema: {
        properties: {
          Name: {
            type: 'string',
            filterable: true,
          },
          Id: {
            type: 'number',
            filterable: true,
          },
        },
      },
      alias: {
        Name: {
          legacy: 'CampaignName',
        },
        Id: {
          legacy: 'CampaignId',
        },
      },
    },
    AdGroup: {
      type: 'object',
      filterable: ['Name', 'Id'],
      schema: {
        properties: {
          Name: {
            type: 'string',
            filterable: true,
          },
          Id: {
            type: 'number',
            filterable: true,
          },
        },
      },
      alias: {
        Name: {
          legacy: 'AdAdGroupName',
        },
        Id: {
          legacy: 'AdGroupId',
        },
      },
    },
    Properties: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
    Labels: {
      type: 'array',
      items: {
        type: 'object',
        $schema: Label,
      },
      filterable: true,
    },
    NativePreference: {
      type: 'string',
      enum: ['None', 'NativePreference'],
      nullable: true,
    },
    TitlePart1: {
      type: 'string',
    },
    TitlePart2: {
      type: 'string',
    },
    Path1: {
      type: 'string',
    },
    Path2: {
      type: 'string',
    },
  },
};

export const mockLabelSchema = {
  name: 'Label',
  type: 'object',
  key: 'Id',
  properties: {
    Id: {
      type: 'integer',
      key: true,
      nullable: true,
    },
    Name: {
      type: 'string',
      maxLength: 80,
      required: true,
    },
    Description: {
      type: 'string',
      maxLength: 200,
    },
    ColorCode: {
      type: 'integer',
      nullable: true,
    },
    AssociationCounts: {
      type: 'object',
      $schema: {
        name: 'LabelAssociationCounts',
        type: 'object',
        properties: {
          CampaignCount: {
            type: 'integer',
          },
          AdGroupCount: {
            type: 'integer',
          },
          AdCount: {
            type: 'integer',
          },
          KeywordCount: {
            type: 'integer',
          },
        },
      },
    },
  },
};
